import { AxiosInstance } from "axios";
import { ItemValue, QuestionDropdownModel, SurveyModel } from "survey-core";

export const registerContext = (
  survey: SurveyModel,
  _api: AxiosInstance,
  context: any,
) => {
  // If only one service partner is present, set it as the initial value
  // If multiple service partners are present, set it to the choices for the service partner question
  const servicePartners = context?.servicePartners || [];

  const servicePartnerChoices = servicePartners.map(
    (sp: any) => new ItemValue(sp.id, sp.fullName),
  );
  const servicePartnerQuestion = survey.getQuestionByName("servicePartner");
  if (servicePartnerQuestion instanceof QuestionDropdownModel) {
    servicePartnerQuestion.choices = servicePartnerChoices;
    // SurveyJS clones ItemValue objects when setting choices, losing custom properties.
    // Re-attach the original service partner data to the processed instances.
    const spById = new Map<string, any>(
      servicePartners.map((sp: any) => [String(sp.id), sp]),
    );
    for (const choice of servicePartnerQuestion.choices) {
      choice.data = spById.get(String(choice.value));
    }
  }

  if (
    servicePartners.length >= 1 &&
    survey.getValue("servicePartner") === undefined
  ) {
    survey.setValue("servicePartner", servicePartners[0].id);
  }

  survey.setVariable("servicePartnersCount", servicePartners.length);

  if (context?.dealership) {
    survey.setVariable("dealership", context.dealership);
  }
};
